module.exports = __webpack_public_path__ + "static/19-c9bb3ff132cbcd2532a54af22b1c9635.jpg";